import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:grid 2xl:grid-cols-4 gap-[25px]" }
const _hoisted_2 = { class: "2xl:col-span-3" }
const _hoisted_3 = { class: "mb-[25px] text-center" }
const _hoisted_4 = { class: "inline-block mx-[3px]" }
const _hoisted_5 = { class: "inline-block mx-[3px]" }
const _hoisted_6 = { class: "inline-block mx-[3px]" }
const _hoisted_7 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_8 = { class: "lg:col-span-1 order-2 lg:order-1" }
const _hoisted_9 = { class: "lg:col-span-2 order-1 lg:order-2" }
const _hoisted_10 = { class: "2xl:col-span-1" }
const _hoisted_11 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] mb-[25px]" }
const _hoisted_12 = { class: "2xl:col-span-2" }
const _hoisted_13 = { class: "2xl:col-span-2" }
const _hoisted_14 = { class: "2xl:col-span-2" }
const _hoisted_15 = { class: "2xl:col-span-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCard = _resolveComponent("ProfileCard")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Friends = _resolveComponent("Friends")!
  const _component_CreatePost = _resolveComponent("CreatePost")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_ProfileIntro = _resolveComponent("ProfileIntro")!
  const _component_Followers = _resolveComponent("Followers")!
  const _component_Following = _resolveComponent("Following")!
  const _component_Photos = _resolveComponent("Photos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ProfileCard),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_RouterLink, {
            to: "/social/profile",
            class: "block py-[8.5px] px-[15px] font-medium rounded-md text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Timeline ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_RouterLink, {
            to: "/social/about",
            class: "block py-[8.5px] px-[15px] font-medium rounded-md text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" About ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_RouterLink, {
            to: "/social/activity",
            class: "block py-[8.5px] px-[15px] font-medium rounded-md text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Activity ")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Friends)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_CreatePost),
          _createVNode(_component_Timeline)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ProfileIntro)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Followers)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Following)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Photos)
        ])
      ])
    ])
  ]))
}